export default __webpack_public_path__ + "static/media/growth.7e2827e3.jpg";